/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Market,
  MarketsClosestRetrieve200,
  MarketsClosestRetrieveParams,
  MarketsListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMarketsListUrl = (params?: MarketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/?${stringifiedParams}` : `/api/markets/`
}

export const marketsList = async (params?: MarketsListParams, options?: Parameters<typeof customFetch>[1]): Promise<Market[]> => {

  return customFetch<Market[]>(getMarketsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMarketsListQueryKey = (params?: MarketsListParams,) => {
    return [
    `/api/markets/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMarketsListQueryOptions = <TData = Awaited<ReturnType<typeof marketsList>>, TError = void>(params?: MarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketsList>>> = ({ signal }) => marketsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketsListQueryResult = NonNullable<Awaited<ReturnType<typeof marketsList>>>
export type MarketsListQueryError = void


export function useMarketsList<TData = Awaited<ReturnType<typeof marketsList>>, TError = void>(
 params: undefined |  MarketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsList>>,
          TError,
          Awaited<ReturnType<typeof marketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsList<TData = Awaited<ReturnType<typeof marketsList>>, TError = void>(
 params?: MarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsList>>,
          TError,
          Awaited<ReturnType<typeof marketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsList<TData = Awaited<ReturnType<typeof marketsList>>, TError = void>(
 params?: MarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketsList<TData = Awaited<ReturnType<typeof marketsList>>, TError = void>(
 params?: MarketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMarketsRetrieveUrl = (id: number,) => {




  return `/api/markets/${id}/`
}

export const marketsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Market> => {

  return customFetch<Market>(getMarketsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMarketsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/markets/${id}/`
    ] as const;
    }


export const getMarketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof marketsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketsRetrieve>>> = ({ signal }) => marketsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof marketsRetrieve>>>
export type MarketsRetrieveQueryError = void


export function useMarketsRetrieve<TData = Awaited<ReturnType<typeof marketsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsRetrieve<TData = Awaited<ReturnType<typeof marketsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsRetrieve<TData = Awaited<ReturnType<typeof marketsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketsRetrieve<TData = Awaited<ReturnType<typeof marketsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMarketsClosestRetrieveUrl = (params: MarketsClosestRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/markets/closest/?${stringifiedParams}` : `/api/markets/closest/`
}

export const marketsClosestRetrieve = async (params: MarketsClosestRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<MarketsClosestRetrieve200> => {

  return customFetch<MarketsClosestRetrieve200>(getMarketsClosestRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMarketsClosestRetrieveQueryKey = (params?: MarketsClosestRetrieveParams,) => {
    return [
    `/api/markets/closest/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMarketsClosestRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError = void>(params: MarketsClosestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketsClosestRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketsClosestRetrieve>>> = ({ signal }) => marketsClosestRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketsClosestRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof marketsClosestRetrieve>>>
export type MarketsClosestRetrieveQueryError = void


export function useMarketsClosestRetrieve<TData = Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError = void>(
 params: MarketsClosestRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsClosestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketsClosestRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsClosestRetrieve<TData = Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError = void>(
 params: MarketsClosestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketsClosestRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketsClosestRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketsClosestRetrieve<TData = Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError = void>(
 params: MarketsClosestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketsClosestRetrieve<TData = Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError = void>(
 params: MarketsClosestRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketsClosestRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketsClosestRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






